// extracted by mini-css-extract-plugin
module.exports = {"about":"AboutComponent_about__dmg4_","topSection":"AboutComponent_topSection__9t9dS"};